module.exports = __webpack_public_path__ + "img/hair_back_female_frizzy_long_mask.da7ec1c4.png";